import { useNavigate, useSearchParams } from 'react-router-dom';
import { ExternalUserFormWizard } from '@/features/external-users/components/ExternalUserFormWizard';

export const ExternalUserCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const societyIdFromUrl = searchParams.get('societyId') || undefined;
  const returnTo = searchParams.get('returnTo') || undefined;

  return (
    <ExternalUserFormWizard
      onComplete={(userId) => navigate(returnTo || `/users-externes/${userId}`)}
      initialSocietyId={societyIdFromUrl}
    />
  );
};
